export default __webpack_public_path__ + "static/media/vouchers.bd925af9.svg";